import type { IAssignedEmployee, IAppUser } from '@/interfaces'
import AppUser from '@/models/AppUser'
class AssignedEmployee implements IAssignedEmployee {
  employeeId: string
  employee: IAppUser

  constructor(employee?: any) {
    this.employeeId = employee?.employeeId
    this.employee = new AppUser(employee?.employee)
  }
}

export default AssignedEmployee
